"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var react_router_dom_2 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var react_i18next_2 = require("react-i18next");
var path_1 = require("../../definition/path");
var useBackWarning_1 = __importDefault(require("../../hook/useBackWarning"));
var storeProvider_1 = require("../../storeProvider");
var WaitingPurchase_module_scss_1 = __importDefault(require("./WaitingPurchase.module.scss"));
var WaitingPurchase = function () {
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var searchParams = (0, react_router_dom_2.useSearchParams)()[0];
    var offerStore = (0, storeProvider_1.useStore)().offerStore;
    var orderId = ((_a = searchParams.get("order-id")) === null || _a === void 0 ? void 0 : _a.trim()) || "";
    var sessionId = ((_b = searchParams.get("session-id")) === null || _b === void 0 ? void 0 : _b.trim()) || offerStore.sessionId;
    (0, useBackWarning_1.default)(t("BACK_WARNING_PAYMENT_FLOW"));
    (0, react_1.useEffect)(function () {
        if (!orderId) {
            navigate(path_1.Page.PaymentFailedPage, { replace: true });
            return;
        }
        var active = true;
        var poll = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, offerStore.syncPurchaseStatus(orderId)];
                    case 1:
                        response = _a.sent();
                        if (!active) {
                            return [2 /*return*/];
                        }
                        if (response.status === "success") {
                            navigate("".concat(path_1.Page.TicketPage, "?session-id=").concat(encodeURIComponent(sessionId)), { replace: true });
                            return [2 /*return*/];
                        }
                        if (response.status === "failed") {
                            navigate(path_1.Page.PaymentFailedPage, { replace: true });
                            return [2 /*return*/];
                        }
                        window.setTimeout(poll, 2000);
                        return [2 /*return*/];
                }
            });
        }); };
        poll();
        return function () {
            active = false;
        };
    }, [navigate, offerStore, orderId, sessionId]);
    return ((0, jsx_runtime_1.jsx)("main", { className: WaitingPurchase_module_scss_1.default.waitingPage, children: (0, jsx_runtime_1.jsxs)("section", { className: WaitingPurchase_module_scss_1.default.waitingCard, children: [(0, jsx_runtime_1.jsx)("h1", { className: WaitingPurchase_module_scss_1.default.waitingTitle, children: t("WAITING_PURCHASE_TITLE") }), (0, jsx_runtime_1.jsx)("p", { className: WaitingPurchase_module_scss_1.default.waitingText, children: t("WAITING_PURCHASE_TEXT") })] }) }));
};
exports.default = (0, react_i18next_2.withTranslation)()((0, mobx_react_1.observer)(WaitingPurchase));
